import { SupportedLocale } from '../enums/supported-locale.enum';
import { getLanguageCodeFromLocale } from '../helpers/get-language-code-from-locale.helper';
import { supportedLocalesMetadata } from './supported-locales-metadata.map';
export const supportedLanguageOptions = Object.values(SupportedLocale).map((locale) => {
    const value = getLanguageCodeFromLocale(locale);
    return {
        value,
        label: `${supportedLocalesMetadata[locale].name.english} (${value.toUpperCase()})`,
        locale,
    };
});
